module.exports = __webpack_public_path__ + "static/media/2020DomesticViolenceAnimatedVideo_1596865341133.49e37d62.docx";